var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON SUN"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.6714 12.5357C19.4599 12.1487 12.7622 16.0568 12.7622 25.4449C12.7622 34.833 19.8044 37.1835 24.5008 37.1835C29.1972 37.1835 36.9805 33.7851 36.9805 24.397C36.9805 15.009 29.1878 12.7575 25.6761 12.5404L25.6714 12.5357Z",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.869 7.06047L24.5009 1",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M40.8369 25.6195H48.8184",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.31599 24.8454L1 24.4301",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M25.7565 42.3187L26.7193 49.04",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M37.509 38.1039L44.0132 43.277",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M37.9529 13.3428L43.4234 8.73132",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M12.7623 12.5073L6.54138 7.06042",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M13.4137 38.1039L7.50427 43.9425",
    stroke: "#EF7056",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSun);
export default __webpack_public_path__ + "static/media/icon-sun.bd3dd2d88298052117ed595cfb0a8418.svg";
export { ForwardRef as ReactComponent };